// planHelpers.js
// Helpers compartidos para convertir un plan en un item de carrito y para
// leer el ID de un plan desde una URL. #added deep link add-to-cart 21/8/26 TG

//----------------------------------------------------------------
// #productize
// El backend activa los planes con: SELECT plan_id FROM products WHERE product_id = ?
// (store-transaction.php). O sea que el `id` que va en el carrito TIENE que ser
// el product_id, no el id del plan. Por eso lo volteamos aquí. TG
//----------------------------------------------------------------
export const productize = (plan) => {
  const { id, product_id, ...rest } = plan;

  return {
    ...rest,
    plan_id: id,
    id: product_id
  };
};

//----------------------------------------------------------------
// #isPurchasable
// Un plan solo se puede comprar si tiene product_id (si no, el backend no sabe
// qué activar) y tiene algún precio. TG
//----------------------------------------------------------------
export const isPurchasable = (plan) => {
  if (!plan) return false;
  if (!plan.product_id) return false; // sin product_id no hay activación posible
  const usd = parseFloat(plan.price || 0);
  const gtq = parseFloat(plan.pricegtq || 0);
  return usd > 0 || gtq > 0;
};

//----------------------------------------------------------------
// #parsePlanId
// Acepta lo que el usuario pegue o lo que mande la app:
//   https://eleven.fit/program/31   ->  "31"
//   https://eleven.fit/add/31       ->  "31"
//   /program/31?utm=x               ->  "31"
//   https://eleven.fit/cart?add=31  ->  "31"
//   31                              ->  "31"
// Devuelve null si no encuentra nada. TG
//----------------------------------------------------------------
export const parsePlanId = (input) => {
  const raw = String(input || '').trim();
  if (!raw) return null;

  if (/^\d+$/.test(raw)) return raw; // solo el número

  const byQuery = raw.match(/[?&](?:add|plan)=(\d+)/i); // ?add=31
  if (byQuery) return byQuery[1];

  const byPath = raw.match(/(?:^|\/)(?:program|add)\/(\d+)/i); // /program/31, /add/31, program/31
  if (byPath) return byPath[1];

  return null;
};

//----------------------------------------------------------------
// #localizePlan
// Los planes traen una columna i18n (JSON en texto) con la forma:
//   {"source":"mixed","es":{...},"en":{...}}
// Si hay traducción para el idioma del sitio la usamos; si no,
// se quedan las columnas originales del plan. #added 24/9/26 TG
//----------------------------------------------------------------
const LOCALIZABLE = ['name', 'description', 'long_description', 'activation_message', 'category', 'main_video']; // #added main_video: un video por idioma 3/10/26 TG

export const localizePlan = (plan, language) => {
  if (!plan) return plan;

  let i18n = plan.i18n;

  // viene como string desde MySQL
  if (typeof i18n === 'string') {
    try {
      i18n = JSON.parse(i18n);
    } catch (e) {
      return plan; // JSON roto, ni modo: nos quedamos con lo que hay
    }
  }

  if (!i18n || typeof i18n !== 'object') return plan;

  const loc = i18n[language];
  if (!loc || typeof loc !== 'object') return plan;

  const out = { ...plan };
  LOCALIZABLE.forEach((key) => {
    const value = loc[key];
    if (typeof value === 'string' && value.trim() !== '') {
      out[key] = value;
    }
  });

  return out;
};

//----------------------------------------------------------------
// #tidyPlanHtml
// El editor del admin (Quill) deja un montón de <p><br></p> vacíos
// para separar. En el plan de Xplosive hay 22, y en pantalla eso se
// ve como huecos gigantes. Los quitamos y dejamos que el CSS maneje
// el espaciado. #added 24/9/26 TG
//----------------------------------------------------------------
export const tidyPlanHtml = (html) => {
  if (!html) return '';

  return String(html)
    // párrafos y encabezados que solo traen un <br>
    .replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
    .replace(/<h([1-6])>(\s|&nbsp;|<br\s*\/?>)*<\/h\1>/gi, '')
    // <br> pegados al final de un bloque, que también abultan
    .replace(/(<br\s*\/?>\s*)+(<\/(p|h[1-6]|li)>)/gi, '$2')
    .trim();
};
